module.exports = __webpack_public_path__ + "static/media/story_2.1af76293.png";